import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const None = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M20.84 20.84L3.16001 3.16L1.89001 4.43L3.78001 6.32C2.66001 7.93 2.00001 9.89 2.00001 12C2.00001 17.52 6.48001 22 12 22C14.11 22 16.07 21.34 17.68 20.23L19.57 22.12L20.84 20.84ZM12 20C7.59001 20 4.00001 16.41 4.00001 12C4.00001 10.45 4.45001 9 5.22001 7.77L6.68001 9.23C6.25001 10.06 6.00001 11 6.00001 12C6.00001 15.31 8.69001 18 12 18C13 18 13.94 17.75 14.77 17.32L16.23 18.78C15 19.55 13.55 20 12 20ZM6.32001 3.77C7.93002 2.66 9.89001 2 12 2C17.52 2 22 6.48 22 12C22 14.11 21.34 16.07 20.23 17.68L18.78 16.23C19.55 15 20 13.55 20 12C20 7.59 16.41 4 12 4C10.45 4 9.00001 4.45 7.77001 5.22L6.32001 3.77ZM18 12C18 13 17.75 13.94 17.32 14.77L9.23001 6.68C10.06 6.25 11 6 12 6C15.31 6 18 8.69 18 12Z" />
  </SvgIcon>
));

None.displayName = 'None';

export default None;
